<template>
  <section class="uk-container-expand">
    <div class="uk-container uk-padding-large" ref="container">
      <h2 class="no-border">&ldquo;Maar ik wil eerst iets vragen&rdquo;</h2>
      <div class="uk-width-2-3@m uk-margin-auto uk-margin-remove-top uk-text-center">
        <p>
          Snap ik!
          Want misschien heb je nog geen definitieve teksten of wil je eerst even iets
          anders overleggen. Geen probleem.
          <br>
          Vul het contactformulier hieronder in en ik mail of bel je zo snel mogelijk terug.
        </p>
        <p class="uk-animation-shake uk-text-danger uk-text-bold" v-if="error"
           id="contactFormError">
          Helaas ging er iets fout met het verzenden. Probeer het nogmaals of stuur mij een
          e-mail via: <a href="mailto:jason@voiceoveracteur.nl">jason@voiceoveracteur.nl</a>
        </p>
        <form class="uk-text-left uk-margin-large" action="" ref="form"
              method="POST" @submit="prevent">
          <div class="" uk-grid>
            <div class="uk-width-1-1@m">
              <label class="uk-form-label" for="contactform[name]">Naam *</label>
              <div class="uk-form-controls">
                <input type="text"
                       id="contactform[name]"
                       name="contactform[name]"
                       ref="contactForm__name"
                       v-model.trim="contactForm.name"
                       class="uk-input" placeholder="Wat is je naam?" required>
              </div>
            </div>

            <div class="uk-width-1-1@m">
              <label class="uk-form-label" for="contactform[email]">E-mailadres *</label>
              <div class="uk-form-controls">
                <input type="email" class="uk-input"
                       id="contactform[email]"
                       name="contactform[email]"
                       ref="contactForm__email"
                       v-model.trim="contactForm.email"
                       placeholder="Wat is je e-mailadres?"
                       required
                >
              </div>
            </div>

            <div class="uk-width-1-1@m">
              <label class="uk-form-label" for="contactform[phone]">Telefoonnummer</label>
              <div class="uk-form-controls">
                <input type="tel" class="uk-input"
                       id="contactform[phone]"
                       name="contactform[phone]"
                       ref="contactForm__phone"
                       v-model.trim="contactForm.phone"
                       placeholder="Wat is je telefoonnummer?"
                >
              </div>
            </div>

            <div class="uk-width-1-1">
              <label
                class="uk-form-label"
                for="contactform[question]">Vraag of opmerking *</label>
              <div class="uk-form-controls">
                    <textarea id="contactform[question]"
                              name="contactform[question]"
                              v-model.trim="contactForm.question"
                              ref="contactForm__question"
                              class="uk-textarea"
                              rows="5"
                              required
                              placeholder="Wat is je vraag?"
                    />
              </div>
            </div>

            <div class="uk-width-1-1 uk-margin-remove-top">
              <button type="submit"
                      class="
                            g-recaptcha
                            uk-button
                            uk-button-default
                            uk-button-large
                            uk-display-block
                            uk-width-auto
                            uk-margin-medium-top uk-margin-auto"

              >
                Vraag verzenden
              </button>
              <br>
              <recaptcha ref="recaptcha"
                         class="uk-hidden"
                         @verify="sendForm"/>
            </div>
          </div>

        </form>
        <p>
          Je kunt mij ook direct mailen op<br>
          <a href="mailto:jason@voiceoveracteur.nl">jason@voiceoveracteur.nl</a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import fetch from 'node-fetch';
import UIkit from 'uikit';
import Recaptcha from './Recaptcha.vue';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const config = require('@/../config');

export default Vue.extend({
  name: 'ContactForm.vue',
  components: { Recaptcha },
  data() {
    return {
      error: false,
      contactForm: {
        name: '',
        email: '',
        phone: '',
        question: '',
      },
    };
  },
  watch: {
    error(value) {
      if (value === true) {
        setTimeout(() => {
          UIkit.scroll(null, { offset: 100 }).scrollTo('#contactFormError');
        }, 500);
      }
    },
  },
  methods: {
    prevent(event) {
      event.preventDefault();
      if (!window.webpackHotUpdate) {
        this.$refs.recaptcha.execute();
      } else {
        this.sendForm();
      }
    },
    disableFormFields() {
      const contactFormKeys = Object.keys(this.contactForm);
      contactFormKeys.forEach((field) => {
        if (this.$refs[`contactForm__${field}`]) {
          this.$refs[`contactForm__${field}`].setAttribute('disabled', 'disabled');
        }
      });
    },
    enableFormFields() {
      const contactFormKeys = Object.keys(this.contactForm);
      contactFormKeys.forEach((field) => {
        if (this.$refs[`contactForm__${field}`]) {
          this.$refs[`contactForm__${field}`].removeAttribute('disabled');
        }
      });
    },
    sendForm() {
      this.disableFormFields();
      this.error = false;

      const contactFormKeys = Object.keys(this.contactForm);
      const formData = {};
      contactFormKeys.forEach((field) => {
        formData[field] = this.contactForm[field];
      });

      fetch(config.contactURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.contactForm),
      }).then((response) => {
        if (response.status < 200 || response.status >= 300) {
          this.error = true;
          return;
        }
        this.$refs.form.innerHTML = ''
          + '<h2 class="no-border">Bedankt voor je bericht! <br>Ik reageer zo snel mogelijk.</h2>';
      }).catch((error) => {
        console.error(error);
        this.error = true;
      }).finally(() => {
        this.enableFormFields();
      });
    },
  },
});
</script>

<style scoped>

</style>
